import { Button } from '@progress/kendo-react-buttons';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Loader } from '@progress/kendo-react-indicators';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { useMemo, useState } from 'react';
import CenterDivPanel from '../../components/CenterDivPanel';
import { fetchApi } from '../../services/api';
import { DocumentClassification } from '../../TypeGen/Order/Images/document-classification';

interface ViewModel {
  TrainedVersion: string;
  Files: string[];
  ChatResponseAnalyzedPages: DocumentClassification[];
}

const DownloadClassifiedEpayDocs = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [epayTransactionId, setEpayTransactionId] = useState<number>(0);
  const [tripNumber, setTripNumber] = useState<number>(0);
  //const [transactionStatusNote, setTransactionStatusNote] = useState('');

  const [viewModel, setViewModel] = useState<ViewModel>();
  //const [downloadedNoAiViewModel, setDownloadedNoAiViewModel] = useState<ViewModel>();
  const [activeView, setActiveView] = useState<'none' | 'no-ai' | 'with-ai'>('none');

  const _downloadFromEpay = () => {
    setLoading(true);

    const data = {
      EpayTransactionId: epayTransactionId ?? 0,
      TripNumber: tripNumber ?? 0,
      SkipAiClassification: true
    };

    fetchApi(`/api/Settlements/DownloadClassifiedEpayDocs`, data, 'POST')
      .then((resp) => {
        setLoading(false);
        setViewModel(resp);
        setActiveView('no-ai');
      })
      .catch(e => {
        setLoading(false);
        if (!e?.status) alert('An error occurred.');
      });
  };

  const _classifyAndDownloadDocs = () => {
    setLoading(true);

    const data = {
      EpayTransactionId: epayTransactionId ?? 0,
      TripNumber: tripNumber ?? 0
    };

    fetchApi(`/api/Settlements/DownloadClassifiedEpayDocs`, data, 'POST')
      .then((resp) => {
        setLoading(false);
        setActiveView('with-ai');
        setViewModel(resp);
        //if (resp.blob.size > 0)
        //  downloadBlobAsFile(resp.blob, resp.filename);
        //else {
        //  alert('No file returned.');
        //}
      })
      .catch(e => {
        setLoading(false);
        if (!e?.status) alert('An error occurred.');
      });
  };


  const canLoad = useMemo(() => Number(epayTransactionId) > 0 || Number(tripNumber) > 0, [epayTransactionId, tripNumber]);

  //const _approve = () => {
  //  setLoading(true);

  //  const data = {
  //    EpayTransactionId: epayTransactionId,
  //    EpayTransactionStatus: 124,
  //    TransactionStatusNote: '',
  //    TripNumber: tripNumber
  //  };

  //  fetchApi(`/api/Settlements/DownloadClassifiedEpayDocs`, data, 'POST')
  //    .then(() => {
  //      setLoading(false);
  //    }
  //    ).catch((e) => {
  //      setLoading(false);
  //      if (!e?.status) alert('An error occurred.');
  //    });
  //};

  //const _reject = () => {
  //  setLoading(true);

  //  const data = {
  //    EpayTransactionId: epayTransactionId,
  //    EpayTransactionStatus: 122,
  //    TransactionStatusNote: transactionStatusNote,
  //    TripNumber: tripNumber
  //  };

  //  fetchApi(`/api/Settlements/DownloadClassifiedEpayDocs`, data, 'POST')
  //    .then(() => {
  //      setLoading(false);
  //    }
  //    ).catch((e) => {
  //      setLoading(false);
  //      if (!e?.status) alert('An error occurred.');
  //    });
  //};

  return <div className="container-fluid">
    {loading && <div className="container"><CenterDivPanel>
      <Loader type="converging-spinner" />
    </CenterDivPanel></div>}
    <h2 className="mt-3">Epay AI Document Classifier {viewModel?.TrainedVersion}</h2>
    <div className="row">
      <div className="col-3">
        <FieldWrapper className="mt-2">
          <NumericTextBox
            placeholder="Epay Transaction ID"
            min={0}
            format="0"
            disabled={loading}
            value={epayTransactionId}
            label="Epay Transaction ID"
            onChange={(e) => setEpayTransactionId(e.value)}
          />
        </FieldWrapper>
        <FieldWrapper className="mt-2">
          <NumericTextBox
            placeholder="Trip Number"
            min={0}
            format="0"
            disabled={loading}
            value={tripNumber}
            label="Trip Number"
            onChange={(e) => setTripNumber(e.value)}
          />
        </FieldWrapper>
        <div className="k-form-buttons mt-4" style={{ display: 'block' }}>
          <FieldWrapper className="mt-2">
            <Button disabled={loading || !canLoad} onClick={() => _downloadFromEpay()}>
              Show Downloaded Images (Without AI)
            </Button>
          </FieldWrapper>         
          <FieldWrapper className="mt-2">
            <Button themeColor="primary" disabled={loading || !canLoad} onClick={() => _classifyAndDownloadDocs()}>
              Show Downloaded Images (With AI)
            </Button>
          </FieldWrapper>
          {/*<Button themeColor="success" disabled={loading || epayTransactionId === 0} className="ml-4" onClick={() => _approve()}>*/}
          {/*  Mark as Approved*/}
          {/*</Button>*/}
          {/*<Button themeColor="error" disabled={loading || epayTransactionId === 0 || isNullOrWhiteSpace(transactionStatusNote)} className="ml-2" onClick={() => _reject()}>*/}
          {/*  Mark as Rejected*/}
          {/*</Button>*/}
        </div>
      </div>
      <div className="col-9">
        <div style={{ height: '80vh', overflowY: 'scroll', overflowX: 'hidden' }}>
          {activeView === 'no-ai' && viewModel?.Files?.length > 0 &&
            viewModel?.Files.map((base64String, index) => (
              <div key={index} className="row mb-4">
                <div className="col-12">
                  <img
                    src={`data:image/jpeg;base64,${base64String}`}
                    alt={`Document Page ${index + 1}`}
                    width={600}
                    style={{ marginTop: 6 }}
                  />
                </div>
              </div>
            ))}

          {activeView === 'with-ai' && viewModel?.Files?.length > 0 && viewModel?.ChatResponseAnalyzedPages?.length === 0 && <div className="alert alert-warning" style={{ width: '475px' }}>
            No classified docs have been returned. This could be indicative of a time-out.
          </div>}

          {activeView === 'with-ai' && viewModel?.Files?.length > 0 && viewModel?.ChatResponseAnalyzedPages?.length > 0 &&
            viewModel?.Files.map((base64String, index) => {
              const page = viewModel.ChatResponseAnalyzedPages[index];
              return (
                <div key={index} className="row mb-4">
                  <div className="col-12">
                    <table className="w-100" style={{ borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td className="w-50">
                            <img
                              src={`data:image/jpeg;base64,${base64String}`}
                              alt={`Document Page ${index + 1}`}
                              width={600}
                              style={{ marginTop: 6 }}
                            />
                          </td>
                          <td className="pl-2 align-top">
                            <table className="table table-sm table-bordered w-100">
                              <tbody>
                                <tr>
                                  <td colSpan={2} className="table-info font-weight-bold" style={{ color: "black" }}>
                                    Classification Info
                                  </td>
                                </tr>
                                {page.IsPhoto && <tr>
                                  <td className="font-weight-bold">Is Photo:</td>
                                  <td>Yes</td>
                                </tr>}
                                <tr>
                                  <td colSpan={2}>{page.InferredDocumentType}</td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>{page.InferredDocumentTypeReason}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}

        </div>
      </div>
    </div>
  </div>
}

export default DownloadClassifiedEpayDocs;
